export default "__VITE_ASSET__Cu8oozQ2__"